/* import __COLOCATED_TEMPLATE__ from './lsg-modal-text-editor.hbs'; */
import { scheduleOnce } from '@ember/runloop';
import { equal } from '@ember/object/computed';
import LSGModalBase from "./lsg-modal-dialog-base";
import { closeModal } from 'sh-www/utils/modal-controls';

/**
 * The possible height styles for the text editor popover.
 *
 * @type {Object}
 */
export const LSG_MODAL_TEXT_EDITOR__HEIGHT_STYLE = {
  MAX_HEIGHT: 'max_height', // set a max height on the internal body
  NO_MAX_HEIGHT: 'no_max_height' // no max height on the internal body. will stretch to fill the screen vertically
};

/**
 * Use this component to show text input with confirmation in modal
 */
export default LSGModalBase.extend({
  /**
   * The model for this modal
   *
   * @param {Object}
   */
  model: {
    /**
     * @param {String}      of type LSG_MODAL_TEXT_EDITOR__HEIGHT_STYLE.*
     */
    heightStyle: LSG_MODAL_TEXT_EDITOR__HEIGHT_STYLE.MAX_HEIGHT,

    /**
     * The title for the modal
     *
     * @param {String}
     */
    title: '',

    /**
     * Callback function after user has approved the text.
     *
     * @param {Function}    callback func with the message as the param.
     */
    onConfirmMessage: function(message) {
      throw new Error('you must define onConfirmAction');
    },

    /**
     * A secondary message to show at the bottom of the modal under the text area.  You may specify these HTML elements
     *
     * HTML Allowed: <br>
     *
     * @param {String}
     */
    secondaryMessage: '',

    /**
     * @param {String}      The subtitle will be shown as an optional blurb of text above the text area
     */
    subtitle: '',

    /**
     * The placeholder for the text area
     *
     * @param {String=}
     */
    textAreaPlaceholder: '',

    /**
     * Cancel button text.
     *
     * @param {String=}
     */
    cancelText: 'Cancel',

    /**
     * Confirm button text
     *
     * @param {String=}
     */
    confirmText: 'Confirm',

    /**
     * Callback function when a user cancels the dialog.
     *
     * @param {Function=}
     */
    onCancelMessage: function() {},
  },

  /**
   * @inheritDoc
   */
  stateDefaults: {
    /**
     * @type {Boolean}      True when the popover has been cancelled.
     */
    isCancelled: false,

    /**
     * @type {Boolean}      True when the popover has been confirmed.
     */
    isConfirmed: false,

    /**
     * User's text they have input.
     *
     * @type {String}
     */
    message: '',

    /**
     * Show the saved message selector
     *
     * @type {Boolean}
     */
    showSavedMessages: false,
  },

  /**
   * @inheritDoc
   */
  _onCloseBeforeModelCleared() {
    if (!this.get('state.isCancelled') && !this.get('state.isConfirmed')) {
      let cancelMessage = this.get('model.onCancelMessage');
      if (cancelMessage) {
        cancelMessage();
      }
    }
  },

  /**
   * @type {Boolean}
   */
  _hasNoMaxHeight: equal('model.heightStyle', LSG_MODAL_TEXT_EDITOR__HEIGHT_STYLE.NO_MAX_HEIGHT),

  /**
   * @inheritDoc
   */
  actions: {
    /**
     * Called when user clicks the 'confirm' button
     */
    onConfirmAction: function() {
      let message = this.get('state.message');
      this.get('model.onConfirmMessage')(message);
      this.set('state.isConfirmed', true);
      closeModal(this);
    },

    /**
     * Called when user clicks the 'cancel' button
     */
    onCancelAction: function() {
      let cancelMessage = this.get('model.onCancelMessage');
      if (cancelMessage) {
        cancelMessage();
      }

      this.set('state.isCancelled', true);
      closeModal(this);
    },

    /**
     * Called when the user selects a saved message
     *
     * @param message
     */
    onMessageSelect(message) {
      const currentValue = this.get('state.message') || '';
      const newValue = currentValue + (currentValue ? '\n' : '') + message.get('body');

      this.setProperties({
        'state.showSavedMessages': false,
        'state.message': newValue,
      });

      scheduleOnce('afterRender', this, () => {
        document.querySelector('.LSG-c-modal-text-editor textarea').focus();
      });
    },

    /**
     * Called when the user selects the saved message call-to-action
     */
    showSavedMessagesModal() {
      this.set('state.showSavedMessages', true);
    },

    /**
     * Called when the user closes the saved messages modal
     */
    closeSavedMessagesModal() {
      this.set('state.showSavedMessages', false);
    },
  },
});
